import React from "react";

export const AccompanyingPersonsInputSection = ({
  formData,
  accompanyingPersonFee,
  accompanyingPersons,
  onNameChange,
  onRemove,
  onAdd,
}) => {
  if (!accompanyingPersonFee) {
    return null;
  }

  return (
    <div className="grid-item grid-item--full">
      <label
        style={{
          display: "block",
          marginBottom: "8px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#000000",
        }}
      >
        Accompanying Persons <span style={{ fontWeight: "400" }}>(Optional)</span>
        <span
          style={{
            fontWeight: "400",
            color: "#000000",
            fontSize: "13px",
          }}
        >
          {" "}
          (Fee: {accompanyingPersonFee.currency} {accompanyingPersonFee.rate} per
          person)
        </span>
      </label>

      {accompanyingPersons.map((person, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "8px",
            marginBottom: "8px",
            padding: person.paid ? "8px" : "0",
            backgroundColor: person.paid ? "#f0f9ff" : "transparent",
            border: person.paid ? "2px solid #28a745" : "none",
            borderRadius: person.paid ? "6px" : "0",
            position: "relative",
          }}
        >
          {person.paid && (
            <div
              style={{
                position: "absolute",
                top: "-1px",
                right: "-1px",
                backgroundColor: "#28a745",
                color: "white",
                padding: "2px 8px",
                fontSize: "11px",
                fontWeight: "bold",
                borderTopRightRadius: "4px",
                borderBottomLeftRadius: "4px",
              }}
            >
              🔒 PAID
            </div>
          )}
          <input
            type="text"
            placeholder={`Accompanying Person ${index + 1} Name *`}
            value={person.name}
            onChange={(event) => onNameChange(index, event.target.value)}
            required
            style={{
              flex: 1,
              backgroundColor: person.paid ? "#e8f5e9" : "white",
              cursor: person.paid ? "not-allowed" : "text",
              color: person.paid ? "#2e7d32" : "#000000",
              fontWeight: person.paid ? "500" : "normal",
              fontSize: "14px",
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            disabled={person.paid}
            title={person.paid ? "⚠️ Payment completed - Cannot modify" : ""}
            readOnly={person.paid}
          />
          <button
            type="button"
            onClick={() => onRemove(index)}
            disabled={person.paid}
            style={{
              padding: "8px 12px",
              backgroundColor: person.paid ? "#e0e0e0" : "#ef4444",
              color: person.paid ? "#9e9e9e" : "white",
              border: "none",
              borderRadius: "4px",
              cursor: person.paid ? "not-allowed" : "pointer",
              fontSize: "13px",
              opacity: person.paid ? 0.5 : 1,
              textDecoration: person.paid ? "line-through" : "none",
            }}
            title={
              person.paid
                ? "⚠️ Cannot remove - Payment completed and cannot be reversed"
                : "Remove"
            }
          >
            Remove
          </button>
        </div>
      ))}

      <button
        type="button"
        onClick={onAdd}
        style={{
          padding: "8px 16px",
          backgroundColor: "#1976d2",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "13px",
          marginTop: "4px",
        }}
      >
        + Add Accompanying Person
      </button>

      {accompanyingPersons.some((person) => person.paid) && (
        <div
          style={{
            marginTop: "8px",
            padding: "10px",
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "4px",
            fontSize: "13px",
            color: "#856404",
          }}
        >
          <strong>⚠️ Important:</strong> Items marked as "PAID" are locked
          because payment has been completed and cannot be reversed. You can add
          new items which will require additional payment.
        </div>
      )}

      {formData.paid && accompanyingPersons.length === 0 && (
        <p
          style={{
            fontSize: "13px",
            color: "#059669",
            fontStyle: "italic",
            marginTop: "8px",
          }}
        >
          ✓ Payment completed. You can still add more accompanying persons if
          needed (additional payment required).
        </p>
      )}
    </div>
  );
};
